module.exports = __webpack_public_path__ + "static/media/auchan.09bba679.svg";